import { useReviewCheckToggleContext } from '#baseMenu/components';
import { useAdvertReviewCheckVisibleControl } from '#reviewCheck/hooks';
import { useMenuActionControlProviderContext, useMenuActionsBlocker } from '#baseMenu/hooks';

const useReviewCheckHandlerClick = () => {
  const {
    isOpen,
    open,
    hide,
  } = useAdvertReviewCheckVisibleControl();
  const {
    ReviewCheck,
    isLoaded,
    setIsLoaded,
    setIsLoadInProcess,
  } = useReviewCheckToggleContext();
  const { menuActionControl } = useMenuActionControlProviderContext();
  const { blockActions, unblockActions } = useMenuActionsBlocker();

  return () => {
    if (!isLoaded) {
      blockActions();
      setIsLoadInProcess(true);
      ReviewCheck.load().then(() => {
        setIsLoaded(true);
        menuActionControl.hide().then(() => {
          unblockActions();
          setIsLoadInProcess(false);
          open();
          menuActionControl.add({ id: 'reviewCheck', hide });
        });
      });
      return;
    }

    if (isOpen) {
      hide();
      menuActionControl.remove('reviewCheck');
    } else {
      menuActionControl.hide().then(() => {
        open();
        menuActionControl.add({ id: 'reviewCheck', hide });
      });
    }
  };
};

export { useReviewCheckHandlerClick };
